

















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
    mdbAlert,
    mdbBtn,
    mdbIcon,
    mdbTooltip,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbView,
    mdbMask,
    mdbMasonry,
    mdbMasonryItem,
    mdbBadge,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
} from '@folky-tools/mdbvue';
import { usersService, businessAddressesService, businessLocationsService, businessesShippingRatesService, notificationsService, globalizationService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessAddress, BusinessAddressType } from '@/models/businesses/business-address';
import { BusinessLocation } from '@/models/businesses/business-location';
import { BusinessShippingRate } from '@/models/businesses/business-shipping-rate';
import { State } from '@/models/globalization/state';
import { BusinessShippingRateService } from '@/models/businesses/business-shipping-rate-service';
import Swal from 'sweetalert2';

@Component({
    components: {
        mdbAlert,
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardImage,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbCardFooter,
        mdbCardUp,
        mdbCardAvatar,
        mdbCardGroup,
        mdbView,
        mdbMask,
        mdbMasonry,
        mdbMasonryItem,
        mdbBadge,
        mdbInput,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        EditPickupAddress: () => import('@/components/businesses/EditPickupAddress.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessLogisticsView extends Vue {
    private businessAddress: BusinessAddress = new BusinessAddress();
    private businessAddressCopy: BusinessAddress = new BusinessAddress();
    private businessLocation: BusinessLocation = new BusinessLocation();
    private businessLocationCopy: BusinessLocation = new BusinessLocation();
    private businessShippingRates: BusinessShippingRate[] = [];
    private states: State[] = [];
    private selectedBusinessShippingRate: BusinessShippingRate = new BusinessShippingRate();

    private showEditBusinessAddress: boolean = false;
    private showEditBusinessLocation: boolean = false;
    private showBusinessShippingRateInfo: boolean = false;

    private savingBusinessAddress: boolean = false;
    private savingBusinessLocation: boolean = false;

    private pageContentLoaded: boolean = false;

    private get selectedBusinessShippingRateService(): BusinessShippingRateService {
        return this.selectedBusinessShippingRate.services && this.selectedBusinessShippingRate.services.length > 0 ? this.selectedBusinessShippingRate.services[0] : new BusinessShippingRateService();
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessLogisticsView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        this.businessAddress = await businessAddressesService.getBusinessAddress(+this.$route.params.id, BusinessAddressType.PickupAddress);
        if (this.businessAddress.businessId < 1) {
            this.businessAddress.businessId = +this.$route.params.id;
        }
        this.businessAddressCopy = this.businessAddress.clone();
        this.businessLocation = await businessLocationsService.getBusinessLocation(+this.$route.params.id);
        if (this.businessLocation.businessId < 1) {
            this.businessLocation.businessId = +this.$route.params.id;
        }
        this.businessLocationCopy = this.businessLocation.clone();
        this.businessShippingRates = await businessesShippingRatesService.getBusinessShippingRates(+this.$route.params.id);

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.Logistics,
                entityId: +this.$route.params.id
            })
        );
        setTimeout(() => this.switchPageContentToLoaded(), 10);
    }

    private switchPageContentToLoaded() {
        this.pageContentLoaded = true;
    }

    private async editBusinessAddress(): Promise<void> {
        if (this.businessAddress.id < 1) {
            this.businessAddress = await businessAddressesService.getBusinessAddress(+this.$route.params.id, BusinessAddressType.FrontPageContactAddress);
            this.businessAddress.id = 0;
        }
        this.showEditBusinessAddress = true;
    }

    private async saveBusinessAddress(): Promise<void> {
        this.savingBusinessAddress = true;

        if ((this.$refs.businessAddress as any).hasErrors()) {
            this.savingBusinessAddress = false;
            return;
        }

        try {
            if (this.businessAddress.id > 0) {
                if (await businessAddressesService.updateBusinessAddress(+this.$route.params.id, this.businessAddress)) {
                    this.businessAddressCopy = this.businessAddress.clone();
                    this.closeBusinessAddressEdition();

                    notificationsService.showToastSuccessNotification('views.businesses.businessLogisticsView.notifications.saveBusinessAddress.success');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.PickupAddress,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }
            } else {
                this.businessAddress.businessId = +this.$route.params.id;
                this.businessAddress.type = BusinessAddressType.PickupAddress;

                const updateResult = await businessAddressesService.newBusinessAddress(+this.$route.params.id, this.businessAddress);
                if (updateResult.result) {
                    this.businessAddress.id = updateResult.id;
                    this.businessAddressCopy = this.businessAddress.clone();
                    this.closeBusinessAddressEdition();

                    notificationsService.showToastSuccessNotification('views.businesses.businessLogisticsView.notifications.saveBusinessAddress.success');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasCreated,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.PickupAddress,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBusinessAddress = false;
        }
    }

    private closeBusinessAddressEdition(): void {
        this.businessAddress = this.businessAddressCopy.clone();
        this.showEditBusinessAddress = false;
    }

    private editBusinessLocation(): void {
        if (this.businessAddress.id < 1) {
            notificationsService.showToastErrorNotification('views.businesses.businessLogisticsView.notifications.editBusinessLocation.error.missingPickupAddress');
            return;
        }

        this.businessLocation.addressId = this.businessAddress.id;
        this.showEditBusinessLocation = true;
    }

    private async saveBusinessLocation(): Promise<void> {
        this.savingBusinessLocation = true;

        try {
            this.businessLocation.allowPickUpCarriers = true;
            if (this.businessLocation.id > 0) {
                if (await businessLocationsService.updateBusinessLocation(+this.$route.params.id, this.businessLocation)) {
                    this.businessLocationCopy = this.businessLocation.clone();
                    this.closeBusinessLocationEdition();

                    notificationsService.showToastSuccessNotification('views.businesses.businessLogisticsView.notifications.saveBusinessLocation.success');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.PickupDelivery,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }
            } else {
                this.businessLocation.businessId = +this.$route.params.id;

                const updateResult = await businessLocationsService.newBusinessLocation(+this.$route.params.id, this.businessLocation);
                if (updateResult.result) {
                    this.businessLocation.id = updateResult.id;
                    this.businessLocationCopy = this.businessLocation.clone();
                    this.closeBusinessLocationEdition();

                    notificationsService.showToastSuccessNotification('views.businesses.businessLogisticsView.notifications.saveBusinessLocation.success');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasCreated,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.PickupDelivery,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBusinessLocation = false;
        }
    }

    private closeBusinessLocationEdition(): void {
        this.businessLocation = this.businessLocationCopy.clone();
        this.showEditBusinessLocation = false;
    }

    private async newBusinessShippingRate(): Promise<void> {
        if (this.businessAddress.id < 1) {
            notificationsService.showToastErrorNotification('views.businesses.businessLogisticsView.notifications.editBusinessLocation.error.missingPickupAddress');
            return;
        }
        this.$router.push(`/businesses/logistics/${this.$route.params.id}/shipping-rate/new?businessName=${this.$route.query.businessName}&stateId=${this.businessAddress.stateId}&postalCodes=${this.businessAddress.postalCode}`);
    }

    private async showBusinessShippingRateMoreInfo(shippingRateId: number): Promise<void> {
        this.selectedBusinessShippingRate = this.businessShippingRates.find(sr => sr.id === shippingRateId)!;
        this.states = await globalizationService.getStates(this.selectedBusinessShippingRateService.destination.countryId);
        this.showBusinessShippingRateInfo = true;
    }

    private async deleteBusinessShippingRate(shippingRateId: number): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$t('views.businesses.businessLogisticsView.notifications.deleteBusinessShippingRate.title').toString(),
            text: this.$i18n.t('views.businesses.businessLogisticsView.notifications.deleteBusinessShippingRate.text').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.businesses.businessLogisticsView.notifications.deleteBusinessShippingRate.confirmButtonText').toString(),
            cancelButtonText: this.$i18n.t('views.businesses.businessLogisticsView.notifications.deleteBusinessShippingRate.cancelButtonText').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            if (await businessesShippingRatesService.deleteBusinessShippingRate(+this.$route.params.id, shippingRateId)) {
                this.businessShippingRates = this.businessShippingRates.filter(shippingRate => shippingRate.id !== shippingRateId);

                notificationsService.showToastSuccessNotification('views.businesses.businessLogisticsView.notifications.deleteBusinessShippingRate.success');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasDeleted,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.ShippingRateService,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }

            notificationsService.showToastErrorNotification();
        }
    }
}
